import * as ActionTypes from './ActionTypes';
import OrderContactAddressApi from './OrderContactAddressApi';
import IOrderContactAddress from './entities/IOrderContactAddress';

function getContactAddressSucceeded(result: any): any {
    return { type: ActionTypes.CONTACT_ADDRESS_SUCCESS, result: result };
}

export function getContactAddress(id: number): any {
    return (dispatch: any, getState: any) =>
        OrderContactAddressApi.getContactAddress(id).then((result: any) => {
            dispatch(getContactAddressSucceeded(result));
        });
}

function updateOrderAddressSucceeded(result: any): any {
    return { type: ActionTypes.UPDATE_ORDER_ADDRESS_SUCCESS, result: result };
}

export function updateOrderAddress(id: number, orderContactAddress: IOrderContactAddress): any {
    return (dispatch: any, getState: any) =>
        OrderContactAddressApi.updateOrderAddress(id, orderContactAddress).then((result: any) => {
            dispatch(updateOrderAddressSucceeded(result));
        });
}

function updateOrderOwnerSucceeded(result: any): any {
    return { type: ActionTypes.UPDATE_ORDER_OWNER_SUCCESS, result: result };
}

export function updateOrderOwner(id: number, orderContactAddress: IOrderContactAddress): any {
    return (dispatch: any, getState: any) =>
        OrderContactAddressApi.updateOrderOwner(id, orderContactAddress).then((result: any) => {
            dispatch(updateOrderOwnerSucceeded(result));
        });
}
